import { NotFound } from 'src/components/base';

export function NotFoundPage() {
  return (
    <div className="w-100 h-100 flex column nowrap justify-content-center align-items-center">
      <NotFound />
    </div>
  );
}
